import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import DefinitionDetails from './DefinitionDetails';
import DefinitionsList from './DefinitionsList';

export interface DefinitionsProps { }

const Definitions: FC<DefinitionsProps> = (props) => {

    return (
        <Switch>
            <Route exact path={'/dashboard/definitions'} component={DefinitionsList} />
            <Route exact path={'/dashboard/definitions/:id'} component={DefinitionDetails} />
        </Switch>
    )
}


export default Definitions